import global$1 from './global.js';
import fails$1 from './fails.js';
import engineWebkitVersion from './engine-webkit-version.js';

var global = global$1;
var fails = fails$1;
var WEBKIT = engineWebkitVersion; // Forced replacement object prototype accessors methods

var objectPrototypeAccessorsForced = !fails(function () {
  // This feature detection crashes old WebKit
  // https://github.com/zloirock/core-js/issues/232
  if (WEBKIT && WEBKIT < 535) return;
  var key = Math.random(); // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call -- required for testing

  __defineSetter__.call(null, key, function () {
    /* empty */
  });

  delete global[key];
});

export { objectPrototypeAccessorsForced as default };
